import { render, staticRenderFns } from "./ManagementPurchasesEdit.vue?vue&type=template&id=12ce653f&scoped=true"
import script from "./ManagementPurchasesEdit.vue?vue&type=script&lang=js"
export * from "./ManagementPurchasesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce653f",
  null
  
)

export default component.exports